import { setCookie } from '@utils/cookie'
import os from '@utils/os'

export default {
  setUserInfos(state, userInfos) {
    state.userInfos = userInfos
  },
  setLogin(state, isLogin) {
    state.isLogin = isLogin
  },
  setUserIdentity(state, userIdentity) {
    state.userIdentity = userIdentity
  },
  setUserLoginData(_, infos) {
    localStorage.setItem('userID', infos.userID || '')
    localStorage.setItem('token', infos.token || '')
  }
}
